import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import clsx from 'clsx';
import {contentActions} from 'client_shared/src/state/actions';
import {useTranslation} from 'react-i18next';
import NewsList from './lists/newsList/NewsList';
import {CONTENT} from 'shared/src';

const useStyles = makeStyles(theme => ({
    layout: {
        display: 'flex',
        flexDirection: 'column',
    }
}));

export default function NewsContentBar() {
    const classes = useStyles();
    const news = useSelector(state => state.content.news);
    const newsCount = useSelector(state => state.content.newsCount);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const { t } = useTranslation();

    async function onMore() {
        if (loading) {
            return;
        }
        setLoading(true);
        const start = news.length + 1;
        await dispatch(contentActions.loadNews(start, start + CONTENT.NEWS_PAGE_SIZE - 1, true));
        setLoading(false);
    }

    return (
        <div className={classes.layout}>
            <NewsList news={news}/>
            {newsCount > news.length &&
            <div className={classes.buttonRow}>
                <div className={clsx('linkBig', classes.moreNews)} onClick={onMore}>{t('Text.MoreNews')}</div>
            </div>
            }
        </div>
    );
};
